export const query = window.location.search.substr(1).split('&').reduce((q, sp) => {
  sp = decodeURIComponent(sp)
  const [k, ...v] = sp.split('=')
  q[k] = v.length ? v.join('=') : true
  return q
}, {})

export const fillLang = (def, langs) => {
  const defLangPkg = langs[def]
  Object.keys(langs).forEach(name => {
    langs[name] = Object.assign({}, defLangPkg, langs[name])
  })
  return langs
}

export const codes = {
  100100: '接口参数错误',
  100101: '用户未登录',
  100120: '用户密码错误',
  100121: '用户不存在',
  100102: 'JSON 解析错误',
  100103: '数据库创建记录失败',
  999999: '未知错误',
}
